import React, { Component } from 'react';
import Modal from 'react-modal';
import { NumberField, PrimaryButton } from '../Ui';
import Form from '../utils/Form';

Modal.defaultStyles = {
	overlay: {
		position: 'fixed',
		top: '65px',
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		zIndex: 4
	},
	content: {
		position: 'absolute',
		top: '25%',
		left: 0,
		right: 0,
		width: '500px',
		margin: '0 auto',

		background: '#fff',
		overflow: 'auto',
		WebkitOverflowScrolling: 'touch',

		outline: 'none',
		padding: '20px'
	}
};

class IterationsModal extends Component {
	state = {
		iterations: 1,
		isLoading: false
	};

	render() {
		const { isOpen, requestCloseFn } = this.props;
		const { iterations, isLoading } = this.state;
		return (
			<Modal
				isOpen={isOpen}
				contentLabel="Iterations modal"
				onRequestClose={requestCloseFn}
			>
				<header className="iterations-modal__title">
					Ajouter combien de motifs ?
				</header>
				<Form onSubmit={this.handleSubmit}>
					<div className="iterations-modal__field">
						<NumberField
							min="1"
							value={iterations}
							onChange={this.handleChange}
						/>
					</div>
					<div className="iterations-modal__submit">
						<PrimaryButton size="small" loading={isLoading} submit>
							Ajouter
						</PrimaryButton>
					</div>
				</Form>
			</Modal>
		);
	}

	handleChange = value => {
		this.setState({ iterations: value });
	};

	handleSubmit = () => {
		const { iterations } = this.state;
		const { onSubmit } = this.props;

		this.setState({ isLoading: true });

		onSubmit(iterations);
	};
}

export default IterationsModal;



// WEBPACK FOOTER //
// ./src/js/PatternDuplication/IterationsModal.js